import { IDirective } from "angular"

import StudentHelperTeacherTemplate from "./student-helper-teacher.html"

export function StudentHelperTeacherDirective(): IDirective {
  return {
    restrict: "E",
    scope: true,
    controller: "StudentHelperTeacherController",
    controllerAs: "ctrl",
    template: StudentHelperTeacherTemplate,
  }
}
